export const useCheckMaxPassengersComposable = () => {
  const checkMaxRoom = (roomInfo: any, maxAdult: number, numOfRooms?: any, tourIndex?: number) => {
    const columns = [
      { field: 'singleNo', peopleNo: 1 },
      { field: 'doubleNo', peopleNo: 2 },
      { field: 'tripleNo', peopleNo: 3 },
      { field: 'quadNo', peopleNo: 4 },
      { field: 'fiveInRoomNo', peopleNo: 5 },
      { field: 'sixInRoomNo', peopleNo: 6 }
    ];
    let total = 0;
    let totalRoom = 0;
    columns.forEach((column: any) => {
      if (typeof tourIndex === 'number') {
        totalRoom += roomInfo[tourIndex][column.field];
        total += roomInfo[tourIndex][column.field] * column.peopleNo;
      } else {
        roomInfo.forEach((item: any) => {
          totalRoom += item[column.field];
          total += item[column.field] * column.peopleNo;
        });
      }
    });
    return total > maxAdult || totalRoom > numOfRooms;
  };

  const checkMinRoom = (roomInfo: any, minAdult: number, numOfRooms?: any, tourIndex?: number) => {
    const columns = [
      { field: 'singleNo', peopleNo: 1 },
      { field: 'doubleNo', peopleNo: 2 },
      { field: 'tripleNo', peopleNo: 3 },
      { field: 'quadNo', peopleNo: 4 },
      { field: 'fiveInRoomNo', peopleNo: 5 },
      { field: 'sixInRoomNo', peopleNo: 6 }
    ];
    let totalPax = 0;
    let totalRoom = 0;
    columns.forEach((column: any) => {
      if (typeof tourIndex === 'number') {
        totalRoom += roomInfo[tourIndex][column.field];
        totalPax += roomInfo[tourIndex][column.field] * column.peopleNo;
      } else {
        roomInfo.forEach((item: any) => {
          totalRoom += item[column.field];
          totalPax += item[column.field] * column.peopleNo;
        });
      }
    });
    return totalPax < minAdult || totalRoom < numOfRooms;
  };

  const checkMinRoomTotal = (roomInfo: any[], occupancyInfo: any[], minAdult: number, numOfRooms?: number): boolean => {
    const columns = [
      { field: 'singleNo', peopleNo: 1 },
      { field: 'doubleNo', peopleNo: 2 },
      { field: 'tripleNo', peopleNo: 3 },
      { field: 'quadNo', peopleNo: 4 },
      { field: 'fiveInRoomNo', peopleNo: 5 },
      { field: 'sixInRoomNo', peopleNo: 6 }
    ];

    let totalAdt = 0;
    let totalRoom = 0;

    roomInfo.forEach((room) => {
      columns.forEach(({ field, peopleNo }) => {
        const count = room[field] ?? 0;
        totalRoom += count;
        totalAdt += count * peopleNo;
      });
    });
    const totalChild = getTotalChild(occupancyInfo);
    return +totalAdt + +totalChild < minAdult || totalRoom < (numOfRooms ?? 0);
  };

  const getChildrenInItem = (item: any): number => {
    const validRoomKeys = ['singleRoom', 'doubleRoom', 'tripleRoom', 'quadRoom', 'fiveRoom', 'sixRoom'];
    return Object.entries(item).reduce((total, [key, value]) => {
      if (Array.isArray(value) && validRoomKeys.includes(key)) {
        return total + value.reduce((sum, room) => sum + (room.children ?? 0), 0);
      }
      return total;
    }, 0);
  };

  const findMatchingCabin = (detail: any[], cabinType: string) => {
    return detail.flat().find((cabin) => cabin.cabinType === cabinType);
  };

  const countChildrenInRooms = (occupancy: any, cabinInfo: any): number => {
    let childrenCount = 0;
    const validRoomKeys = {
      singleNo: 'singleRoom',
      doubleNo: 'doubleRoom',
      tripleNo: 'tripleRoom',
      quadNo: 'quadRoom',
      fiveInRoomNo: 'fiveRoom',
      sixInRoomNo: 'sixRoom'
    };
    for (const [countKey, roomKey] of Object.entries(validRoomKeys)) {
      const roomCount = cabinInfo[countKey];
      if (roomCount && roomCount > 0 && Array.isArray(occupancy[roomKey])) {
        const selectedRooms = occupancy[roomKey].slice(0, roomCount);
        childrenCount += selectedRooms.reduce((sum, room) => sum + (room.children ?? 0), 0);
      }
    }

    return childrenCount;
  };

  const calculateChildrenInGroupCruise = (detail: any[], cabinInfos: any[]): number => {
    return cabinInfos.reduce((total, cabinInfo) => {
      const matchingCabin = findMatchingCabin(detail, cabinInfo.cabinType);
      if (!matchingCabin?.detailedOccupancy) {
        return total;
      }

      const occupancy = matchingCabin.detailedOccupancy;
      return total + countChildrenInRooms(occupancy, cabinInfo);
    }, 0);
  };

  const getTotalChildrenCruise = (data: any[][]): number => {
    return data.reduce((sum, group) => sum + calculateChildrenInGroupCruise(group.cabinDetailOccupancies, group.cabinInfos), 0);
  };

  const getTotalChild = (occupanyList: any[]): number => {
    return occupanyList.reduce((total, item) => total + getChildrenInItem(item), 0);
  };

  const checkMaxSeat = (items: any, maxAdult: any) => {
    let total = 0;
    items.map((item: any) => {
      total += item.numberOfSeats;
    });
    return total > maxAdult;
  };

  const checkMinSeat = (items: any, minSeat: any) => {
    let total = 0;
    items.map((item: any) => {
      total += item.numberOfSeats;
    });
    return total < minSeat;
  };

  const checkMaxSeatAir = (items: any, minPax: number = 1, maxPax?: number) => {
    let total = 0;

    items.map((item: any) => {
      total += (item.adtNo ?? 0) + (item.chdNo ?? 0);
    });

    return total >= minPax && (!maxPax || total <= maxPax);
  };

  const calculateCabinStats = (items: any) => {
    const columns = [
      { field: 'singleNo', peopleNo: 1 },
      { field: 'doubleNo', peopleNo: 2 },
      { field: 'tripleNo', peopleNo: 3 },
      { field: 'quadNo', peopleNo: 4 },
      { field: 'fiveInRoomNo', peopleNo: 5 },
      { field: 'sixInRoomNo', peopleNo: 6 }
    ];

    let total = 0;
    let totalPeople = 0;

    items.forEach((item: any) => {
      columns.forEach((column) => {
        const count = item[column.field] ?? 0;
        total += count;
        totalPeople += count * column.peopleNo;
      });
    });

    return { total, totalPeople };
  };

  const checkMaxCabin = (items: any, maxCabin: number, maxAdult: number) => {
    const { total, totalPeople } = calculateCabinStats(items);
    return total > maxCabin || totalPeople > maxAdult;
  };

  const calculateCabinFromInfo = (cabinInfos: any[]): { cabins: number; people: number } => {
    const cabinColumns = [
      { field: 'singleNo', peopleNo: 1 },
      { field: 'doubleNo', peopleNo: 2 },
      { field: 'tripleNo', peopleNo: 3 },
      { field: 'quadNo', peopleNo: 4 },
      { field: 'fiveInRoomNo', peopleNo: 5 },
      { field: 'sixInRoomNo', peopleNo: 6 }
    ];
    return cabinInfos.reduce(
      (acc, item) => {
        for (const column of cabinColumns) {
          const count = item[column.field] ?? 0;
          acc.cabins += count;
          acc.people += count * column.peopleNo;
        }
        return acc;
      },
      { cabins: 0, people: 0 }
    );
  };

  const calculateCabinInfo = (items: any[]): { totalCabins: number; totalPeople: number } => {
    let totalCabins = 0;
    let totalPeople = 0;

    for (const detailInfo of items) {
      if (!detailInfo?.cabinInfos) {
        continue;
      }
      const { cabins, people } = calculateCabinFromInfo(detailInfo.cabinInfos);
      totalCabins += cabins;
      totalPeople += people;
    }

    totalPeople += getTotalChildrenCruise(items);

    return { totalCabins, totalPeople };
  };

  const checkMinCabin = (items: any, minCabin: number, minPax: number) => {
    const { totalCabins, totalPeople } = calculateCabinInfo(items);
    return totalCabins < minCabin || totalPeople < minPax;
  };

  return {
    checkMaxRoom,
    checkMinRoom,
    checkMinRoomTotal,
    getChildrenInItem,
    getTotalChild,
    checkMaxSeat,
    checkMaxSeatAir,
    checkMaxCabin,
    checkMinSeat,
    checkMinCabin,
    calculateChildrenInGroupCruise,
    getTotalChildrenCruise,
    countChildrenInRooms,
    findMatchingCabin
  };
};
